import { useGetDomainAttributesQuery } from '../../api';
import { mergeErrorStates, mergeLoadingStates } from '../../api/helpers';
import useActiveDomainData from '../../ontology/hooks/useActiveDomainData';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useMemo } from 'react';
import useActiveDomainAttributes
	from "../../ontology/hooks/useActiveDomainAttributes";

const useAttrActionData = () => {
	const { activeItem: activeDomain } = useActiveDomainData();

	const domainAttrs = useActiveDomainAttributes();

	return useMemo(() => {
		const isLoading = mergeLoadingStates(domainAttrs);

		const errors = mergeErrorStates(domainAttrs);

		return {
			isLoading,
			errors,
			domainAttrs: domainAttrs.activeItems || null,
			domainAttrQueryResult: domainAttrs,
		};
	}, [domainAttrs]);
};

export default useAttrActionData;
